<template>

    <div class="report-parameters">

        <div class="grid grid-cols-6 gap-6">
            <div class="form-control col-span-6 xl:col-span-4" v-for="field in value.report_structure.fields" >
                <label :for="'field_' + field.alias">{{ field.label }}</label>

                <select :name="field.alias" :id="'field_' + field.alias" v-model="value.report_parameters[field.alias]" v-if="field.type === 'select'">
                    <option value="null">Select {{ field.label }}</option>
                    <option :value="option[field.model_select_value]" v-for="option in field.options">
                        {{ option[field.model_select_name] }}
                    </option>
                </select>

                <datetime v-else-if="field.type === 'datetime'" :title="field.label" :id="'field_' + field.alias" @input="formatDate( $event,'datetime', field.alias)" type="datetime" v-model="value.report_parameters[field.alias]" @input-selected="setFieldValue" :class="{ 'hidden': shouldHideField(field) }" :placeholder="field.label"></datetime>

                <datetime v-else-if="field.type === 'date'" :title="field.label" :id="'field_' + field.alias" type="date" @input="formatDate( $event,'date', field.alias)" format="y-LL-dd" @input-selected="setFieldValue" v-model="value.report_parameters[field.alias]" :class="{ 'hidden': shouldHideField(field) }" :placeholder="field.label"></datetime>

                <datetime v-else-if="field.type === 'time'" :title="field.label" :id="'field_' + field.alias" type="time" @input="formatDate( $event,'time', field.alias)" format="TT" v-model="value.report_parameters[field.alias]" @input-selected="setFieldValue" :class="{ 'hidden': shouldHideField(field)}" :placeholder="field.label"></datetime>

                <input v-else :id="'field_' + field.alias" :type="field.type" v-model="value.report_parameters[field.alias]" :placeholder="field.label">

                <div v-if="shouldHideField(field)" class="fake-input-disabled">{{ field.label }}</div>

                <p v-if="shouldHideField(field)" class="text-sm text-gray-400 mt-2">
                    <slot name="disabled-help-text"></slot>
                </p>
            </div>

            <div class="form-control col-span-6 xl:col-span-4">
                <label for="export_driver" class="block text-sm font-medium text-gray-700">Export Type<i></i></label>

                <select name="export_driver" id="export_driver" v-model="value.report_parameters['export_driver']" aria-required="true" required autocomplete="off">
                    <option :value="driver.value" v-for="driver in value.report_structure.queued_export_drivers">{{ driver.name }}</option>
                </select>
            </div>
        </div>

    </div>

</template>

<script>
import {Datetime} from "vue-datetime";
import {DateTime as LuxonDateTime} from "luxon";
import {FormattingMixin} from "../../support/mixins";

export default {
    name: "ReportParameters",
    mixins: [FormattingMixin],
    props: {
        value: {
            type: Object
        },
        show_date_fields: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    components: {
        datetime: Datetime,
    },
    methods: {
        formatDate(date, type, alias) {
            if (date) {
                let dt = LuxonDateTime.fromISO(date);

                if (type === 'datetime') {
                    this.value.report_parameters[alias] = dt.toISO();
                } else if (type === 'date') {
                    this.value.report_parameters[alias] = dt.toISODate();
                } else if (type === 'time') {
                    this.value.report_parameters[alias] = dt.toISOTime();
                }
            }
        },
        shouldHideField(field) {
            return (this.show_date_fields === false && (field.type === 'datetime' || field.type === 'date' || field.type === 'time'));
        },
        setFieldValue(event) {
            this.data.data[event.name] = event.value;
        },
    }
}
</script>